import { render, staticRenderFns } from "./CriterioAceptacion.vue?vue&type=template&id=50fa3d4d"
import script from "./CriterioAceptacion.vue?vue&type=script&lang=js"
export * from "./CriterioAceptacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports